module.exports = __webpack_public_path__ + "static/media/bodegaFinMundo.cdf2afdf.svg";